import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3909f7fd")

_pushScopeId("data-v-3909f7fd")
const _hoisted_1 = {
  class: "test",
  style: {"min-width":"768px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"margin-left":"10px"} }, [
  /*#__PURE__*/_createVNode("span", {
    class: "geo-style2",
    style: {"font-size":"21px","color":"#fff"}
  }, "Game"),
  /*#__PURE__*/_createVNode("span", {
    class: "geo-style2",
    style: {"font-size":"21px","color":"#fff"}
  }, "Robot")
], -1)
const _hoisted_3 = { style: {"color":"#ffffff","font-size":"1rem"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_6 = { style: {"color":"#ffffff","font-size":"1rem"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("请登录")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      type: "flex",
      align: "middle",
      style: {"padding":"5px","border-radius":"5px"},
      justify: "space-between"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_col, {
          xs: 20,
          sm: 20,
          md: 20,
          lg: 20,
          xl: 13
        }, {
          default: _withId(() => [
            _createVNode(_component_el_row, {
              type: "flex",
              justify: "space-between",
              align: "middle"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 0.5 }, null, 8, ["span"]),
                _createVNode(_component_el_col, {
                  style: {"display":"flex","align-items":"center"},
                  span: 6
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_link, {
                      href: "/",
                      underline: false
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_image, {
                          src: _ctx.logoUrl,
                          style: {"width":"60px","height":"47px"},
                          fit: "contain"
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }),
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 18 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_row, {
                      type: "flex",
                      justify: "space-between",
                      align: "middle",
                      id: "nav"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuItem, (item) => {
                          return (_openBlock(), _createBlock(_component_el_button, {
                            type: "text",
                            round: "",
                            key: item.menuName,
                            class: "navButton",
                            textContent: _toDisplayString(item.menuName),
                            disabled: 
                  item.menuName === '下载' || item.menuName === '帮助中心'
                ,
                            href: item.href,
                            style: {"color":"#ffffff","font-size":"1rem"},
                            onClick: ($event: any) => (_ctx.goto(item))
                          }, null, 8, ["textContent", "disabled", "href", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 4,
          sm: 4,
          md: 4,
          lg: 4,
          xl: 4,
          style: {"padding-right":"24px"}
        }, {
          default: _withId(() => [
            _createVNode(_component_el_row, {
              type: "flex",
              justify: "end",
              align: "middle"
            }, {
              default: _withId(() => [
                (_ctx.isLogin)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, {
                      key: 0,
                      onCommand: _ctx.onClick,
                      trigger: "click"
                    }, {
                      dropdown: _withId(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_is_super
                    ? _ctx.loginState.sub2
                    : _ctx.loginState.sub, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: index,
                                command: item.path,
                                icon: item.icon
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["command", "icon"]))
                            }), 128)),
                            _createVNode(_component_el_dropdown_item, {
                              command: "/login_new",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLogout())),
                              icon: "el-icon-switch-button"
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withId(() => [
                        _createVNode("span", _hoisted_3, [
                          _createTextVNode(_toDisplayString(_ctx.getMe.username) + " ", 1),
                          _hoisted_4
                        ])
                      ]),
                      _: 1
                    }, 8, ["onCommand"]))
                  : (_openBlock(), _createBlock(_component_el_dropdown, {
                      key: 1,
                      onCommand: _ctx.onClick
                    }, {
                      dropdown: _withId(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.loginOut.sub, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: index,
                                command: item.path
                              }, {
                                default: _withId(() => [
                                  _hoisted_7
                                ]),
                                _: 2
                              }, 1032, ["command"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withId(() => [
                        _createVNode("span", _hoisted_6, [
                          _createVNode("i", {
                            class: _ctx.loginOut.icon
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(_ctx.loginOut.title), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onCommand"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})